<template>
  <div class="sidebar">
    <div class="categories-section">
      <div class="categories-list">
        <router-link
          v-for="(category, index) in categories"
          :key="`category-${index}`"
          :to="'/category/?c=' + category.slug"
          class="category-link"
        >
          <span class="category-text">
            <i :class="category.icon" class="category-icon"></i>
            {{ category.name }}
          </span>
        </router-link>
      </div>
    </div>
    <div class="top-10-card">
      <h3 class="top-10-title">Top 5 This Week</h3>
      <div class="line mb-4"></div>

      <router-link
        v-for="(bookWrapper, index) in topBooks"
        :key="`top-books-${index}`"
        :to="'/book/' + bookWrapper.book._id"
        class="top-book-item"
      >
        <div class="top-book-number">{{ index + 1 }}</div>
        <img
          :src="
            bookWrapper.book.images?.[0] ?
            `${BASE_IMAGE_PREFIX}/${bookWrapper.book.images[0]}` :
            'https://libreture.com/static/images/book-placeholder.png'
          "
          :alt="bookWrapper.book.title"
          class="top-book-cover"
        />
        <div class="top-book-info">
          <div class="top-book-title">{{ bookWrapper.book.title }}</div>
          <div
            v-if="bookWrapper.book.productCategory !== 'stationary'"
            class="top-book-author"
          >
            {{ bookWrapper.book.author }}
          </div>
          <div class="top-book-price">৳ {{ bookWrapper.book.minVariant.price }}</div>
        </div>
      </router-link>
    </div>

    <!-- Best Seller this week -->
    <div class="best-seller">
      <h3 class="top-10-title">Best Seller</h3>
      <div class="line mb-4"></div>

      <router-link
        v-for="(bookWrapper, index) in bestSellerBooks"
        :key="`top-books-${index}`"
        :to="'/book/' + bookWrapper.book._id"
        class="top-book-item"
      >
        <img
          :src="
            bookWrapper.book.images?.[0] ?
            `${BASE_IMAGE_PREFIX}/${bookWrapper.book.images[0]}` :
            'https://libreture.com/static/images/book-placeholder.png'
          "
          :alt="bookWrapper.book.title"
          class="top-book-cover"
        />
        <div class="top-book-info">
          <div class="top-book-title">{{ bookWrapper.book.title }}</div>
          <div class="top-book-author">{{ bookWrapper.book.author }}</div>
          <div class="top-book-price">৳ {{ bookWrapper.book.minVariant.price }}</div>
        </div>
      </router-link>
    </div>

    <!-- Sidebar banner -->
    <div v-if="sideBanner.length" class="sidebar-banner">
      <a :href="`/search/?c=${sideBanner[0]?.linkTo}`" class="banner-link">
        <img
          :src="
            sideBanner[0]?.imageUrl ?
            `${BASE_IMAGE_PREFIX}/${sideBanner[0]?.imageUrl}` :
            'https://libreture.com/static/images/book-placeholder.png'
          "
          alt="Best Seller Books - Shop Now"
          class="banner-image"
        />
      </a>
    </div>

    <!-- Sidebar Stats -->
    <sidebar-stats :analytics="analytics" />
  </div>
</template>

<script>
import { BASE_IMAGE_PREFIX } from '@/globals';
import SidebarStats from "./SidebarStats.vue";
export default {
  components: { SidebarStats },
  name: "SidebarComponent",
  props: {
    topBooks: {
      type: Array,
      default: () => [],
    },
    bestSellerBooks: {
      type: Array,
      default: () => [],
    },
    sideBanner: {
      type: Array,
      default: () => [],
    },
    analytics: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      BASE_IMAGE_PREFIX,
      categories: [
        {
          name: "Business",
          icon: "bi bi-briefcase",
          slug: "business",
        },
        {
          name: "Religion",
          icon: "bi bi-peace",
          slug: "religion",
        },
        {
          name: "Self Help",
          icon: "bi bi-emoji-smile",
          slug: "self_help",
        },
        {
          name: "Literature",
          icon: "bi bi-journal-bookmark",
          slug: "literature",
        },
        {
          name: "Science Fiction",
          icon: "bi bi-cpu",
          slug: "science_fiction",
        },
        {
          name: "Children & Teens",
          icon: "bi bi-people",
          slug: "children_and_teens",
        },
        {
          name: "Biographies & Memoirs",
          icon: "bi bi-person-lines-fill",
          slug: "biographies_and_memoirs",
        },
        {
          name: "Politics History and Tradition",
          icon: "bi bi-bank",
          slug: "politics_history_and_tradition",
        },
        {
          name: "Information and Technology",
          icon: "bi bi-motherboard",
          slug: "information_and_technology",
        },
        {
          name: "Stationery & Craft",
          icon: "bi bi-pencil-square",
          slug: "stationery_and_craft",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
/* ############### */
/* Sidebar */

.sidebar {
  background: white;
  border-radius: 8px;
  /* padding: 20px; */
}

.categories-section {
  background: white;
  border-radius: 0 0 12px 12px;
  border: 2px solid var(--primary-color);
  border-top: none; 
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 0;
  overflow: hidden;
}

.categories-header {
  background-color: var(--primary-color);
  color: white;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 500;
}

.categories-list {
  padding: 15px 0;
}

.category-link {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #666;
  text-decoration: none;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.category-link:last-child {
  border-bottom: none;
}

.category-link:hover {
  color: var(--primary-color);
  background-color: rgba(242, 84, 80, 0.05);
}

.category-icon {
  // width: 20px;
  // height: 20px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  margin-right: 5px;
  opacity: 0.5;
  font-size: 18px;
}

.category-link:hover .category-icon {
  opacity: 1;
}

.category-text {
  font-size: 15px;
  font-weight: 400;
}
// Top 10 books

.top-10-card {
  background: #f0f1f5;
  border-radius: 12px;
  padding: 24px;
  margin-top: 30px;
}

.best-seller {
  border: 1px solid #e7e7e7;
  border-radius: 12px;
  padding: 24px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.top-10-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 24px;
}

.line {
  flex-grow: 1;
  height: 1px;
  background-color: #e7e7e7;
}

.top-book-item {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s;
  position: relative;
}

.top-book-item:hover {
  transform: translateX(5px);
}

.top-book-number {
  width: 28px;
  height: 28px;
  background: #98d8d0;
  border: 2px solid #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--secondary-color);
  flex-shrink: 0;
  position: absolute;
  top: -10px;
  left: -10px;
}

.top-book-cover {
  width: 80px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
}

.top-book-info {
  flex-grow: 1;
}

.top-book-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
  color: #333;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 65%;
}

.top-book-author,
.top-book-price {
  font-size: 12px;
  color: #666;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 65%;
}

// Banner

.sidebar-banner {
  max-width: 320px;
  margin: 0 auto;
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 30px;

  .banner-link {
    display: block;

    &:hover {
      opacity: 0.95;
    }
  }

  .banner-image {
    width: 100%;
    height: auto;
    display: block;
  }
}

@media (max-width: 767px) {
  .sidebar-banner {
    max-width: 100%;
  }
}
</style>

